import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'have_there_been_any_incidences_of_forced_labor_including_sale_a'

export const dataPointDefinition = {
  retracedId: 'have_there_been_any_incidences_of_forced_labor_including_sale_a',
  name: 'Have there been any incidences of forced labor, including sale and trafficking, prostitution, pornography, or illegal activities involving workers under age 18, or work that exposes them to physical, psychological or sexual abuse?',
  description:
    'These unconditional worst forms of child labor are forbidden in all cases and regardless of national law. Unconditional worst forms of child labor are: slavery or practices similar to slavery, such as sale and trafficking for commercial sexual exploitation or labor exploitation; forced labor; prostitution; pornography; and illegal activities (e.g. drug production and trafficking and the unlawful carrying or use of firearms or other weapons).\r\r\n\r\r\nIncidences apply to violence and harassment in the world of work occurring in the course of, linked with or arising out of work:\r\r\n(a) in the workplace, including public and private spaces where they are a place of work;\r\r\n(b) in places where the worker is paid, takes a rest break or a meal, or uses sanitary, washing and changing facilities;\r\r\n(c) during work-related trips, travel, training, events or social activities;\r\r\n(d) through work-related communications, including those enabled by information and communication technologies;\r\r\n(e) in employer-provided accommodation; and\r\r\n(f) when commuting to and from work.',
  meta: {},
  fieldTypeId: 'YES_NO',
  type: 'RELATIONAL',
  options: [
    {
      name: 'Yes',
      key: 'YES',
      slcpIndex: 1,
      slcpOptionName: 'yes-no',
    },
    {
      name: 'No',
      key: 'NO',
      slcpIndex: 2,
      slcpOptionName: 'yes-no',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
        enum: ['YES', 'NO'],
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'rh-chi-11',
      version: '1.6.0',
      provider: 'slcp',
    },
  ],
  sortingId: 4720,
  sectionId: '2.2.1',
  impactArea: 'Child Labour',
  impactAreaId: 'CHILD_LABOR',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
